import axios from "axios";
import { serviceUrl } from "../../config";
import { checkSessionIsActive, getSessionData } from "../utilfunctions/utilFunctions";
import { resetSession } from "./sessions";

const BACKEND_URL = serviceUrl;

export const ListSummarybyUserJSON = async (
  userID,
  thisduration,
  isAdmin,
  startDate,
  endDate,
  userFilter,
  typeFilter,
  isUsingFilter
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "reporting",
      pid: "ListSummarybyUserJSON",
      dat: {
        userID: userID,
        thisduration: thisduration,
        thisdateA: startDate,
        thisdateB: endDate,
        isadmin: isAdmin,
        userFilter: userFilter,
        transactiontype: typeFilter,
        isUsingFilter: isUsingFilter,
        ...sessionData
      },
    });
    // console.log(thisduration, 1);
    console.log(isAdmin)

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const AdminListSummarybyUserJSON = async (
  userID,
  thisduration,
  isAdmin,
  startDate,
  endDate,
  userFilter,
  typeFilter,
  isUsingFilter
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "reporting",
      pid: "ListSummarybyUserJSON2",
      dat: {
        userID: userID,
        thisduration: thisduration,
        thisdateA: startDate,
        thisdateB: endDate,
        isadmin: isAdmin,
        userFilter: userFilter,
        transactiontype: typeFilter,
        isUsingFilter: isUsingFilter,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ATMListSummarybyUserJSON = async (
  userID,
  thisduration,
  isAdmin,
  startDate,
  endDate,
  userFilter,
  typeFilter,
  isUsingFilter
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "reporting",
      pid: "ListSummarybyUserJSON3",
      dat: {
        userID: userID,
        thisduration: thisduration,
        thisdateA: startDate,
        thisdateB: endDate,
        isadmin: isAdmin,
        userFilter: userFilter,
        transactiontype: typeFilter,
        isUsingFilter: isUsingFilter,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ListDetailbyUserJSON = async (
  thisduration,
  transactiontype,
  startDate,
  endDate,
  currency,
  isAdmin,
  userID,
  filterUser,
) => { 
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "reporting",
      pid: "ListDetailbyUserJSON",
      dat: {
        thisduration: thisduration,
        thisdateA: startDate,
        thisdateB: endDate,
        transactiontype: transactiontype,
        currency: currency,
        isAdmin: isAdmin,
        userID: userID,
        userFilter: filterUser,
        ...sessionData
      },
    });
    console.log(thisduration, 1);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ATMListDetailbyUserJSON = async (
  thisduration,
  transactiontype,
  startDate,
  endDate,
  currency,
  isAdmin,
  userID,
  filterUser,
) => { 
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "reporting",
      pid: "ATMListDetailbyUserJSON",
      dat: {
        thisduration: thisduration,
        thisdateA: startDate,
        thisdateB: endDate,
        transactiontype: transactiontype,
        currency: currency,
        isAdmin: isAdmin,
        userID: userID,
        userFilter: filterUser,
        ...sessionData
      },
    });
    console.log(thisduration, 1);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ListTransactionSummarybyUser = async (
  // thisduration,
  // startDate,
  // endDate,
  // userID
  userID,
  thisduration,
  isAdmin,
  startDate,
  endDate,
  userFilter,
  typeFilter,
  isUsingFilter
) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "ListTransactionSummarybyUser",
      dat: {
        thisduration: thisduration,
        thisdateA: startDate,
        thisdateB: endDate,
        userID: userID,
        ...sessionData
      },
    });
    // console.log(thisduration, 1);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ListSubAcctTransactionHistory = async (thisDateDetails) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "ListSubAcctTransactionHistory",
      dat: {
        thisDateDetails: thisDateDetails,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const PrintPDFSummary = async (thisduration, thisdateA, thisdateB) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "runPDF_Summary",
      dat: {
        thisduration: thisduration,
        thisdateA: thisdateA,
        thisdateB: thisdateB,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const PrintPDFDetailed = async (thisduration, thisdateA, thisdateB) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "runPDF_Detailed",
      dat: {
        thisduration: thisduration,
        thisdateA: thisdateA,
        thisdateB: thisdateB,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const PrintExcel = async (thisDateDetails) => {
  try {
    const sessionData = getSessionData();
    console.log(thisDateDetails)
    const data = JSON.stringify({
      svc: "reporting",
      pid: "runExcel",
      dat: {
        thisDateDetails: thisDateDetails,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const listVouchers = async (userid) => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "transactions2",
      pid: "listVouchers",
      dat: {
        userid: userid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const reportingDetails = async (recid, transtype) => {
  
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "RunQuery",
      dat: {
        param: `${recid}/${transtype}`,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getCustomerWithID = async (id) => {
  
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "GetCustomerWithID",
      dat: {
        userid: id,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

//txid is the alphanumeric code
//transferid is the numeric ID
export const cancelTransaction = async (userid, txcode, transferid) => {
  
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "transactions2",
      pid: "cancelTransaction",
      dat: {
        userid: userid,
        transferid: transferid,
        txid: txcode,
        ...sessionData
      },
    });
    console.log(data);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
}

export const ListUsers = async (userid) => {
  
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "ListUserType",
      dat: {
        userid: userid,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ListTransactionType = async (langID) => {
  
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "ListTransactionTypes",
      dat: {
        langID: langID,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ListAgentAccounts = async () => {
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "Listsubusers",
      dat: {
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const runPDFService = async (
  startdate,
  enddate,
  recordcount,
  records,
  isAdmin,
  agentFirstName,
  agentLastName,
  reportType,
  reportTypeLabel,
  reportParentLabel
) => {
  
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "runPDF_SD_Detailed",
      dat: {
        startdate: startdate,
        enddate: enddate,
        recordcount: recordcount,
        records: records,
        isAdmin: isAdmin,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        reportType: reportType,
        reportTypeLabel: reportTypeLabel,
        reportParentLabel:reportParentLabel,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteFile = async (
  filename
) => {
  
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "deleteFile",
      dat: {
        filename: filename,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const runPDFTH = async (
  startdate,
  enddate,
  records,
  accountName,
  agentFirstName,
  agentLastName,
  availablebalance,
  unavailablebalance,
  withdrawaltotal,
  deposittotal
) => {
  
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "runPDF_TH",
      dat: {
        startdate: startdate,
        enddate: enddate,
        records: records,
        accountName: accountName,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        availablebalance: availablebalance,
        unavailablebalance: unavailablebalance,
        withdrawaltotal: withdrawaltotal,
        deposittotal: deposittotal,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const runPDFVH = async (
  startdate,
  enddate,
  records,
  accountName,
  agentFirstName,
  agentLastName,
  availablebalance,
  unavailablebalance,
  withdrawaltotal,
  deposittotal
) => {
  
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "runPDF_VH",
      dat: {
        startdate: startdate,
        enddate: enddate,
        records: records,
        accountName: accountName,
        agentFirstName: agentFirstName,
        agentLastName: agentLastName,
        availablebalance: availablebalance,
        unavailablebalance: unavailablebalance,
        withdrawaltotal: withdrawaltotal,
        deposittotal: deposittotal,
        ...sessionData
      },
    });

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const ViewAllOperators = async (
  thisduration,
  startDate,
  endDate,
  userID
) => {
  
  try {
    const sessionData = getSessionData();
    const data = JSON.stringify({
      svc: "reporting",
      pid: "ListSubAcctTransactionHistory2",
      dat: {
        thisduration: thisduration,
        thisdateA: startDate,
        thisdateB: endDate,
        userID: userID,
        ...sessionData
      },
    });
    // console.log(thisduration, 1);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }
    // console.log(response);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUserReports = async (
  startdate,
  enddate,
  userstatus
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "reporting",
      pid: "getUserReports",
      dat: {
        startdate: startdate,
        enddate: enddate,
        userstatus: userstatus,
        ...sessionData
      },
    });
    // console.log(thisduration, 1);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUserOFACReports = async (
  startdate,
  enddate,
  ofacstatus
) => {
  const sessionData = getSessionData();
  try {
    const data = JSON.stringify({
      svc: "reporting",
      pid: "getUserOFACReports",
      dat: {
        startdate: startdate,
        enddate: enddate,
        ofacstatus: ofacstatus,
        ...sessionData
      },
    });
    // console.log(thisduration, 1);

    const config = {
      method: "post",
      url: BACKEND_URL,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    const response = await axios(config);
    const sessionActive = checkSessionIsActive(response.data);
    if (!sessionActive) {
      resetSession();
    }

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

